import { connect } from "react-redux";
import { refreshLoan } from "../actions";

const mapDispatchToProps = (dispatch) => ({
  setRefreshLoan: (data) => {
    dispatch(refreshLoan(data));
  },
});

const mapStateToProps = (state) => ({
  refreshLoan: state.refreshLoan,
});

export default connect(mapStateToProps, mapDispatchToProps);